<script lang="ts">
	import type { BlockComponentProps } from '@portabletext/svelte';
	import type { Snippet } from 'svelte';

	interface Props {
		portableText: BlockComponentProps & { value: { url: string; external: boolean } };
		children: Snippet;
	}

	let { portableText, children }: Props = $props();
</script>

<a
	href={portableText.value.url}
	class="text-green-3"
	target={portableText.value.external ? '_blank' : null}
	rel={portableText.value.external ? 'noopener noreferrer' : null}>{@render children()}</a
>
